<!DOCTYPE html>
<router-outlet></router-outlet>
<focc-loader></focc-loader>
